import React, { Suspense, lazy } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { CoreProducts } from '../components/CoreProducts';
import { LoanCalculator } from '../components/LoanCalculator';
import { HowItWorks } from '../components/HowItWorks';
import { Testimonials } from '../components/Testimonials';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { ScrollProgress } from '../components/ScrollProgress';
import { CookieBanner } from '../components/CookieBanner';
import { ChatWidget } from '../components/ChatWidget';
// Lazy load less critical components
const ValueAddedServices = lazy(() => import('../components/ValueAddedServices').then(module => ({
  default: module.ValueAddedServices
})));
const ReferralProgram = lazy(() => import('../components/ReferralProgram').then(module => ({
  default: module.ReferralProgram
})));
const SpecializedServices = lazy(() => import('../components/SpecializedServices').then(module => ({
  default: module.SpecializedServices
})));
const TradeFinanceHub = lazy(() => import('../components/TradeFinanceHub').then(module => ({
  default: module.TradeFinanceHub
})));
const AGPOKnowledgeHub = lazy(() => import('../components/AGPOKnowledgeHub').then(module => ({
  default: module.AGPOKnowledgeHub
})));
const FastTrackPortal = lazy(() => import('../components/FastTrackPortal').then(module => ({
  default: module.FastTrackPortal
})));
const AssetMarketplace = lazy(() => import('../components/AssetMarketplace').then(module => ({
  default: module.AssetMarketplace
})));
const AIAgent = lazy(() => import('../components/AIAgent').then(module => ({
  default: module.AIAgent
})));
// Loading component
const SectionLoader = () => <div className="py-16 flex items-center justify-center" role="status" aria-label="Loading content" data-id="element-1661">
    <div className="w-12 h-12 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin" aria-hidden="true" data-id="element-1662"></div>
    <span className="sr-only" data-id="element-1663">Loading...</span>
  </div>;
export const Home = () => {
  return <div className="min-h-screen flex flex-col" data-id="element-1664">
      <Header data-id="element-1665" />
      <ScrollProgress data-id="element-1666" />
      <main id="main-content" className="flex-grow" role="main" data-id="element-1667">
        <Hero data-id="element-1668" />
        <Features data-id="element-1669" />

        {/* Core Products Section */}
        <CoreProducts data-id="element-1670" />

        {/* Loan Calculator */}
        <LoanCalculator data-id="element-1671" />

        {/* Lazy loaded sections */}
        <Suspense fallback={<SectionLoader data-id="element-1673" />} data-id="element-1672">
          <ValueAddedServices data-id="element-1674" />
        </Suspense>

        <Suspense fallback={<SectionLoader data-id="element-1676" />} data-id="element-1675">
          <ReferralProgram data-id="element-1677" />
        </Suspense>

        <Suspense fallback={<SectionLoader data-id="element-1679" />} data-id="element-1678">
          <SpecializedServices data-id="element-1680" />
        </Suspense>

        <Suspense fallback={<SectionLoader data-id="element-1682" />} data-id="element-1681">
          <TradeFinanceHub data-id="element-1683" />
        </Suspense>

        <Suspense fallback={<SectionLoader data-id="element-1685" />} data-id="element-1684">
          <AGPOKnowledgeHub data-id="element-1686" />
        </Suspense>

        <Suspense fallback={<SectionLoader data-id="element-1688" />} data-id="element-1687">
          <FastTrackPortal data-id="element-1689" />
        </Suspense>

        <Suspense fallback={<SectionLoader data-id="element-1691" />} data-id="element-1690">
          <AssetMarketplace data-id="element-1692" />
        </Suspense>

        <Suspense fallback={<SectionLoader data-id="element-1694" />} data-id="element-1693">
          <AIAgent data-id="element-1695" />
        </Suspense>

        {/* Supporting Sections */}
        <HowItWorks data-id="element-1696" />
        <Testimonials data-id="element-1697" />
        <Contact data-id="element-1698" />
      </main>
      <Footer data-id="element-1699" />
      <CookieBanner data-id="element-1700" />
      <ChatWidget data-id="element-1701" />
    </div>;
};